import { formatINR } from "@/lib/format";

export const KpiCard = ({ label, value, sub, tone = "default", icon: Icon, testId, isCurrency = true }) => {
  const toneClasses = {
    default: "text-zinc-950",
    positive: "text-emerald-700",
    warning: "text-amber-700",
    danger: "text-rose-600",
  };
  return (
    <div
      className="bg-white rounded-xl border border-zinc-200 p-5 shadow-[0_1px_2px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_16px_rgba(0,0,0,0.04)] transition-shadow"
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500">
          {label}
        </div>
        {Icon && <Icon className="h-4 w-4 text-zinc-400" />}
      </div>
      <div className={`mt-3 font-display text-3xl lg:text-4xl font-semibold tracking-tight tabular ${toneClasses[tone]}`}>
        {isCurrency ? formatINR(value) : value}
      </div>
      {sub && <div className="mt-2 text-xs text-zinc-500">{sub}</div>}
    </div>
  );
};

export default KpiCard;
